module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm3.3c8f4c63982569a5a0bad843e216cd4b.png";